/** tidewater.app for m.okafor@tidewater.app */
export const emailDomain = (email: string): string => email.split('@')[1]?.toLowerCase() ?? '';
